export enum BluetoothDataTypes {
  Waage = 0,
  Transponder = 1,
  TierIdent = 2,
}
